/**
 * @file components/SponsorInfo/component.js
 * @copyright 2019 CBC/Radio-Canada. All rights reserved.
 */

import Image from "../ImageWrapper/component";
import LinkWrap from "../LinkWrap/component";
import Title from "../Title/component";
import {
    SPONSORINFO_IMAGE_DERIVATIVE_WIDTHS,
    SPONSORINFO_IMAGE_SIZE,
} from "./constants";
import styles from "../Title/styles/themes/default.module.scss";
/**
 * The SponsorInfo component. Renders sponsor widget on FLP.
 *
 * This component generate a list of sponsors if logo links exist
 *
 * @param {Object} props The component props
 * @returns {React.Component} Returns the SponsorInfo component
 */
export function SponsorInfo(props) {
    let sponsor = props.sponsorContent;

    if (
        !sponsor ||
        !sponsor.sponsorList ||
        (sponsor.sponsorList && !sponsor.sponsorList.length > 0)
    ) {
        return null;
    }

    return (
        <div
            className={`sponsorInfo ${styles.sponsorInfo}`}
            data-testid="sponsor-info"
        >
            <Title level="h2">{sponsor.heading}</Title>
            <ul className="sponsorBoxList">
                {sponsor.sponsorList.map(generateSponsor)}
            </ul>
        </div>
    );
}

function generateSponsor(logo, index) {
    return (
        <li className="sponsorListItem" key={`${index}-sponsor}`}>
            {logo.link ? (
                <LinkWrap
                    className="sponsorLink"
                    url={logo.link}
                    external={true}
                    target="_blank"
                    aria-label={logo.title}
                >
                    <Image
                        url={logo.imageURL}
                        derivativeWidths={SPONSORINFO_IMAGE_DERIVATIVE_WIDTHS}
                        sizes={SPONSORINFO_IMAGE_SIZE}
                        type="sponsor-image"
                        alt={logo.title}
                    />
                </LinkWrap>
            ) : (
                <Image
                    url={logo.imageURL}
                    derivativeWidths={SPONSORINFO_IMAGE_DERIVATIVE_WIDTHS}
                    sizes={SPONSORINFO_IMAGE_SIZE}
                    type="sponsor-image"
                    alt={logo.title}
                />
            )}
        </li>
    );
}

export default SponsorInfo;
